import * as React from 'react';
import cn from 'classnames';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label: string;
    isRequired?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, isRequired, label, ...props }, ref) => {
    return (
        <div className="flex w-full flex-col gap-2">
            {label && (
                <label className="anonymize-p3 text-black-700">
                    {label}
                    {!!isRequired && <span className="text-red-500">*</span>}
                </label>
            )}
            <input type={type} className={cn('border-input anonymize-p4 flex h-[45px] w-full rounded-[4px] border px-[13px] py-3  text-black-800 placeholder:text-black-400', className)} ref={ref} {...props} />
        </div>
    );
});
Input.displayName = 'Input';

export { Input };
